import { StreetViewComponent } from './../../street-view/street-view.component';
import { Component, OnInit, Inject } from '@angular/core';
import { PanelCiudadano } from '../../../../../../_entities/panelCiudadano/panelCiudadano';
import { PanelAdministracionService } from '../../../../../panel-vigilancia/services/panel-administracion.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { MapaService } from '../../../../services/mapa.service';
import { HistoricoPanelComponent } from '../historico-panel/historico-panel.component';

@Component({
  selector: 'kt-informacion-panel',
  templateUrl: './informacion-panel.component.html',
  styleUrls: ['./informacion-panel.component.scss']
})
export class InformacionPanelComponent implements OnInit {
  public panel:PanelCiudadano;
  public direccion: string;
  constructor(private mapaService:MapaService,
    private panelService:PanelAdministracionService,
    public dialog: MatDialog,
		public dialogRef: MatDialogRef<InformacionPanelComponent>,
		@Inject(MAT_DIALOG_DATA) public data: PanelCiudadano,
		) { }

  ngOnInit() {
    this.obtenerPanel(this.data)
  }
  
  obtenerPanel(panel){
		this.mapaService.getDireccion([panel.lng, panel.lat]).then(
			(data: any) => {
				this.direccion = data.display_name || "Dirección Desconocida";
			},
			() => {
				this.direccion = "Dirección Desconocida";
			});

		this.panel = panel;
  }

  ubicarPanel(){
    this.dialogRef.close();
		this.mapaService.verPanel(this.data);
  }
  public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

	verStreet() {
		/*StreetView Popup*/
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.width = "45%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.data;
		this.dialog.open(StreetViewComponent, dialogConfig);
	}
  historicoPanel(){
    const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "50%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.data;
		this.dialog.open(HistoricoPanelComponent, dialogConfig);
		this.dialogRef.close();
  }
}
